/* import __COLOCATED_TEMPLATE__ from './impersonating-as-user.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import Component from '@glimmer/component';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type ImpersonatingAsUser from 'embercom/objects/inbox/renderable/impersonating-as-user';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';
// @ts-expect-error
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { type SafeString } from '@ember/template/-private/handlebars';
import type Session from 'embercom/services/session';
interface ImpersonatingAsUserPart extends RenderablePart {
  renderableData: ImpersonatingAsUser;
}

interface Args {
  part: ImpersonatingAsUserPart;
}

interface Signature {
  Args: Args;
}

export default class Inbox2ConversationStreamEventPartsImpersonatingAsUserComponent extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare session: Session;

  targetRoute = 'apps.app.users.user';

  get renderableData() {
    return this.args.part.renderableData;
  }

  get isFinStandaloneApp() {
    return this.session.workspace?.isStandaloneApp || false;
  }

  get userDisplayNameLinkHtml(): SafeString {
    if (this.isFinStandaloneApp) {
      return sanitizeHtml(this.renderableData.userDisplayName);
    }

    let url = this.router.urlFor(this.targetRoute, this.renderableData.userId, {
      app_id: this.session.workspace.id,
    });
    return sanitizeHtml(
      `<a href="${url}" class="no-underline hover:text-link" target="_blank" data-test-impersonating-as-user-link>${this.renderableData.userDisplayName}</a>`,
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::ImpersonatingAsUser': typeof Inbox2ConversationStreamEventPartsImpersonatingAsUserComponent;
    'inbox2/conversation-stream/event-parts/impersonating-as-user': typeof Inbox2ConversationStreamEventPartsImpersonatingAsUserComponent;
  }
}
